var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('iv-cell-string',_vm._b({},'iv-cell-string',{ ..._vm.$attrs, ..._vm.$props, value: _vm.text },false)),_c('iv-form-cron',_vm._b({directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],on:{"text":function($event){_vm.text = $event}}},'iv-form-cron',{
            row: {},
            name: '',
            value: _vm.value,
        },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }